<template>
  <div class="admin">
    <TabMenu :model="items" />
    <router-view />
  </div>
</template>

<script>
import TabMenu from 'primevue/tabmenu';

export default {
  name: 'Admin',
  components: {
    TabMenu
  },
  data() {
    return {
      items: [
        {label: 'Home', icon: 'pi pi-fw pi-home', to: '/manage'},
        {label: 'Quotations', icon: 'pi pi-fw pi-calendar', to: '/manage/quotations'},
        {label: 'Tasks', icon: 'pi pi-fw pi-pencil', to: '/manage/tasks'},
        {label: 'Users', icon: 'pi pi-fw pi-file', to: '/manage/users'}
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .admin {
  }
</style>
